// CompanyListWithMoreInfo.jsx
import React from "react";

const CompanyListWithMoreInfo = ({ images }) => {
  const renderImageBlock = (image, index) => {
    return (
      <a
        href={image.barcodeUrl}
        key={image.id}
        target="_blank"
        rel="noreferrer"
      >
        <div className="imagexf-container" key={image.id}>
          <img src={image.logoUrl} alt={image.alt} />
        </div>
      </a>
    );
  };

  return (
    <div className="CompanyListWithMoreInfo_container">
      <div className="left-side">{images.map(renderImageBlock)}</div>
      {/* <div className="right-side">
        <img src={require("./img/leng.png")} alt="Logo" />
        <div className="view-more">
          <div className="item">了</div>
          <div className="item">解</div>
          <div className="item">更</div>
          <div className="item">多</div>
        </div>
      </div> */}
    </div>
  );
};

export default CompanyListWithMoreInfo;
